import { GET_APP_SETTING_BY_NAME, GET_APP_SETTINGS_BY_NAME } from 'requests'

export const setAppSetting = setting => ({
  type: 'SET_APP_SETTING',
  setting
})

export const setAppSettings = settings => ({
  type: 'SET_APP_SETTINGS',
  settings
})

export const getAppSettingByName = (name, callback, errorCallback, forceRefetch) => (getState, dispatch) => {
  const existingSetting = getState().appSettings[name]

  if(!existingSetting || forceRefetch){
    GET_APP_SETTING_BY_NAME(name, setting => {
      dispatch(setAppSetting(setting))
      if(typeof callback === "function"){
        callback(setting)
      }
    }, err => {
      console.error(err)
      if(typeof errorCallback === "function"){
        errorCallback(err)
      }
    })
  }else{
    if(typeof callback === "function"){
      callback(existingSetting)
    }
  }
}

const reduceSettings = (names, getState) =>
  names.reduce((obj, name) => {
    obj[name] = getState().appSettings[name]
    return obj
  }, {})


export const getAppSettingsByName = (names, callback, errorCallback, forceRefetch) => (getState, dispatch) => {
  const missingSettings = names.filter(name => !getState().appSettings[name])

  if(missingSettings.length || forceRefetch){
    GET_APP_SETTINGS_BY_NAME(forceRefetch ? names : missingSettings, settings => {
      dispatch(setAppSettings(settings))
      const newSettings = {...reduceSettings(names, getState), ...settings}
      if(typeof callback === "function"){
        callback(newSettings)
      }
    }, err => {
      console.error(err)
      if(typeof errorCallback === "function"){
        errorCallback(err)
      }
    })
  }else{
    const settings = reduceSettings(names, getState)
    if(typeof callback === "function"){
      callback(settings)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/AppSettings/AppSettingActions.js